enum AuthSubview {
    SignIn = 'signin',
    SignInEmail = 'signin-email',
    SignInLibrary = 'signin-library',

    SignUpEmail = 'signup-email',
    EmailVerification = 'email-confirmation',

    ForgotPwd = 'forgot-pwd',
}

export { AuthSubview };
